import React, { useState } from 'react';
import BicycleCard from './BicycleCard';
import BicyclePopup from './BicyclePopup';
import bicycleData from '../../data/bicycles.json'; // You'll need to create this JSON file
import './Bicycles.css';

// If you don't have the JSON file yet, use this sample data:
const sampleBicycleData = [
  {
    id: 1,
    title: "Mountain Explorer",
    description: "A sturdy mountain bike perfect for campus rides and weekend adventures. Features 21-speed gear system and comfortable seating.",
    imagePath: "/api/placeholder/300/200",
    priceRental: 150,
    priceSelling: 2500,
    sold: false
  },
  {
    id: 2,
    title: "City Cruiser",
    description: "Comfortable city bike ideal for daily commutes. Lightweight frame with basket for carrying books and essentials.",
    imagePath: "/api/placeholder/300/200",
    priceRental: 120,
    priceSelling: 1800,
    sold: false
  },
  {
    id: 3,
    title: "Speed Demon",
    description: "High-performance road bike for speed enthusiasts. Aerodynamic design with premium components.",
    imagePath: "/api/placeholder/300/200",
    priceRental: 200,
    priceSelling: 3500,
    sold: true
  },
  {
    id: 4,
    title: "Classic Rider",
    description: "Vintage-style bicycle with modern reliability. Perfect blend of classic aesthetics and contemporary functionality.",
    imagePath: "/api/placeholder/300/200",
    priceRental: 100,
    priceSelling: 1500,
    sold: false
  },
  {
    id: 5,
    title: "Campus Companion",
    description: "Specially designed for student life. Durable, comfortable, and affordable for everyday campus navigation.",
    imagePath: "/api/placeholder/300/200",
    priceRental: 80,
    priceSelling: 1200,
    sold: false
  },
  {
    id: 6,
    title: "Eco Warrior",
    description: "Environmentally conscious choice with recycled components. Contributes to sustainable transportation.",
    imagePath: "/api/placeholder/300/200",
    priceRental: 130,
    priceSelling: 2000,
    sold: true
  }
];

const BicyclesSection = () => {
  const [selectedBicycle, setSelectedBicycle] = useState(null);
  
  // Use imported data if available, otherwise use sample data
  const dataToUse = typeof bicycleData !== 'undefined' ? bicycleData : sampleBicycleData;
  
  // Sort bicycles so that sold ones appear at the end
  const sortedBicycles = [...dataToUse].sort((a, b) => {
    if (a.sold === b.sold) {
      return 0; // Keep original order for items with same sold status
    }
    return a.sold ? 1 : -1; // Put sold items (true) at the end
  });

  return (
    <section className="bicycles-section">
      <div className="bicycles-container">
        <h2 className="section-title">Our Available Bicycles</h2>
        <div className="bicycles-grid">
          {sortedBicycles.map(bicycle => (
            <BicycleCard 
              key={bicycle.id} 
              bicycle={bicycle} 
              onClick={setSelectedBicycle}
            />
          ))}
        </div>
      </div>
      {selectedBicycle && (
        <BicyclePopup 
          bicycle={selectedBicycle} 
          onClose={() => setSelectedBicycle(null)} 
        />
      )}
    </section>
  );
};

export default BicyclesSection;